"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typesafe_actions_1 = require("typesafe-actions");
exports.serverError = typesafe_actions_1.createAction('@server/error')();
exports.joinGameError = typesafe_actions_1.createAction('@server/joinGameError')();
exports.forceSubmit = typesafe_actions_1.createAction('@server/forceSubmit')();
